var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceReconnect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.467 5.336H18.883C19.6787 5.336 20.4418 5.65207 21.0044 6.21468C21.567 6.77729 21.883 7.54035 21.883 8.336V18.449",
    stroke: "#76BC21",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.335 1.5L12.215 4.594C12.1213 4.68696 12.0469 4.79756 11.9961 4.91942C11.9453 5.04128 11.9192 5.17199 11.9192 5.304C11.9192 5.43601 11.9453 5.56672 11.9961 5.68858C12.0469 5.81044 12.1213 5.92104 12.215 6.014L15.553 9.324",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 21.634C24.75 23.349 23.347 24.75 21.602 24.75C19.858 24.75 18.455 23.349 18.455 21.634C18.455 19.918 19.858 18.518 21.603 18.518C23.347 18.518 24.75 19.918 24.75 21.634Z",
    stroke: "#76BC21",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5329 22.664H9.11694C8.32129 22.664 7.55823 22.348 6.99562 21.7853C6.43301 21.2227 6.11694 20.4597 6.11694 19.664V9.55103",
    stroke: "#76BC21",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.665 26.5L15.785 23.406C15.8788 23.3131 15.9531 23.2025 16.0039 23.0806C16.0547 22.9587 16.0808 22.828 16.0808 22.696C16.0808 22.564 16.0547 22.4333 16.0039 22.3114C15.9531 22.1896 15.8788 22.079 15.785 21.986L12.447 18.676",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 6.366C3.25 4.651 4.653 3.25 6.397 3.25C8.142 3.25 9.545 4.651 9.545 6.366C9.545 8.082 8.142 9.482 6.397 9.482C4.653 9.482 3.25 8.082 3.25 6.366Z",
    stroke: "#76BC21",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceReconnect);
export default __webpack_public_path__ + "static/media/serviceReconnect.f1c75f45c5fd10a55dc057ffb3fb6194.svg";
export { ForwardRef as ReactComponent };